module.exports = __webpack_public_path__ + "media/application/images/svgs/public_square/language-634e2589c11b1cbd0420e4141f89ce2a.svg";